"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccordionBehaviours = void 0;
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var AccordionSelection_1 = require("Project/QwilrEditor/Widgets/AccordionWidget/AccordionSelection");
var WidgetActions = __importStar(require("../WidgetActions"));
var BehaviourBuilder_1 = require("../BehaviourBuilder");
var AccordionActions_1 = require("./AccordionActions");
var TelemetryParameterValue_1 = require("Telemetry/TelemetryParameterValue");
var Utils_1 = require("Project/QwilrEditor/Utils");
var BehaviourName;
(function (BehaviourName) {
    BehaviourName["SelectAccordion"] = "selectAccordion";
    BehaviourName["SetAccordionExpanded"] = "setAccordionExpanded";
    BehaviourName["DeleteAccordion"] = "deleteAccordion";
    BehaviourName["CloneAccordion"] = "cloneAccordion";
    BehaviourName["UpdateAccordionSelection"] = "updateAccordionSelection";
    BehaviourName["OnEnterWhenSelected"] = "OnEnterWhenSelected";
    BehaviourName["OnBackspaceWhenSelected"] = "OnBackspaceWhenSelected";
    BehaviourName["OnDeleteWhenSelected"] = "OnDeleteWhenSelected";
    BehaviourName["EnterAtEndOfAccordionHeading"] = "enterAtEndOfAccordionHeading";
    BehaviourName["QuickCreateAccordion"] = "quickCreateAccordion";
    BehaviourName["SwapAccordionImage"] = "swapAccordionImage";
    BehaviourName["EnsureVisualAccordionImages"] = "ensureVisualAccordionImages";
    BehaviourName["OnBackspaceAtStartOfAccordionHeading"] = "onBackspaceAtStartOfAccordionHeading";
    BehaviourName["OnBackspaceAfterCollapsedAccordion"] = "onBackspaceAfterCollapsedAccordion";
    BehaviourName["TabInsideAccordionDummy"] = "tabInsideAccordionDummy";
    BehaviourName["TabInsideAccordionHeading"] = "tabInsideAccordionHeading";
    BehaviourName["TabInsideAccordionBody"] = "tabInsideAccordionBody";
    BehaviourName["ShiftTabInsideAccordionDummy"] = "shiftTabInsideAccordionDummy";
    BehaviourName["ShiftTabInsideAccordionHeading"] = "shiftTabInsideAccordionHeading";
    BehaviourName["ShiftTabInsideAccordionBody"] = "shiftTabInsideAccordionBody";
})(BehaviourName || (BehaviourName = {}));
var getAccordionBehaviours = function (di) {
    var editorTelemetry = di.get("editorTelemetry");
    var currentBlockType = di.get("blockStore").blockType;
    var stockImagesService = di.get("stockImageService");
    var blockStyleStore = di.get("blockStore").blockStyleStore;
    return {
        onSelectAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.SelectAccordion)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Accordion, action: EditorTypes_1.AccordionActionType.SelectAccordion })
            .doAction(function (event, editor) {
            (0, AccordionSelection_1.selectAccordion)(editor, event.data.path);
            return true;
        }),
        onSetAccordionExpanded: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.SetAccordionExpanded)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Accordion, action: EditorTypes_1.AccordionActionType.SetExpanded })
            .doAction(function (event, editor) {
            (0, AccordionActions_1.setExpanded)(editor, event.data.path, event.data.expanded);
            editorTelemetry.accordionToggled(event.data.expanded);
            return true;
        }),
        onDeleteAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.DeleteAccordion)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "accordion", action: "delete" })
            .doAction(function (event, editor) {
            WidgetActions.removeWidget(editor, event.data.path);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.Accordion);
            return true;
        }),
        onCloneAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.CloneAccordion)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "accordion", action: "clone" })
            .doAction(function (event, editor) {
            (0, AccordionActions_1.cloneAccordionWidget)(editor, event.data.path);
            editorTelemetry.accordionDuplicated();
            return true;
        }),
        onUpdateAccordionSelection: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.UpdateAccordionSelection)
            .isEvent(EditorTypes_1.EventType.Selection)
            .doAction(function (_event, editor) {
            return (0, AccordionActions_1.updateAccordionSelection)(editor);
        }),
        onEnterInsertParagraphBelow: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.OnEnterWhenSelected)
            .inBlockType(EditorTypes_1.BlockType.AccordionDummy)
            .selectionIsCollapsed()
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.insertParagraphBelowAccordion)(editor);
            return true;
        }),
        onDeleteKeyPress: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.OnDeleteWhenSelected)
            .inBlockType(EditorTypes_1.BlockType.AccordionDummy)
            .selectionIsCollapsed()
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Delete)
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.deleteAccordionWidget)(editor);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.Accordion);
            return true;
        }),
        onBackspaceKeyPress: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.OnBackspaceWhenSelected)
            .inBlockType(EditorTypes_1.BlockType.AccordionDummy)
            .selectionIsCollapsed()
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.deleteAccordionWidget)(editor);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.Accordion);
            return true;
        }),
        onEnterAtEndOfAccordionHeading: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.EnterAtEndOfAccordionHeading)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .selectionIsCollapsed()
            .isOfAncestry(EditorTypes_1.BlockType.AccordionHeading)
            .doAction(function (event, editor) {
            var handled = (0, AccordionActions_1.enterAtEndOfAccordionHeading)(editor);
            if (handled) {
                event.preventDefault();
            }
            return handled;
        }),
        onQuickCreateAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.QuickCreateAccordion)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .withModifier(BehaviourBuilder_1.KeyModifier.CtrlCmd)
            .isOfAncestry([EditorTypes_1.BlockType.AccordionHeading, EditorTypes_1.BlockType.AccordionBody])
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.quickCreateAccordion)(editor, blockStyleStore, stockImagesService);
            editorTelemetry.inlineContentAdded({
                contentType: TelemetryParameterValue_1.ContentAddedType.Accordion,
                origin: TelemetryParameterValue_1.ContentAddedOrigin.Keyboard,
                blockType: currentBlockType,
                isInsideSideBySide: false,
            });
            return true;
        }),
        onSwapAccordionImage: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.SwapAccordionImage)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Accordion, action: EditorTypes_1.AccordionActionType.SwapImage })
            .doAction(function (event, editor) {
            var path = event.data.path;
            (0, AccordionActions_1.pickBackgroundImage)(di, editor, path);
            return true;
        }),
        onEnsureVisualAccordionImages: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.EnsureVisualAccordionImages)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Accordion, action: EditorTypes_1.AccordionActionType.EnsureVisualAccordionImages })
            .doAction(function (_event, editor) {
            (0, AccordionActions_1.ensureVisualAccordionImages)(editor, stockImagesService);
            return true;
        }),
        onBackspaceAtStartOfAccordionHeading: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.OnBackspaceAtStartOfAccordionHeading)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .selectionIsCollapsed()
            .isOfAncestry(EditorTypes_1.BlockType.AccordionHeading)
            .atStartOfBlock()
            .doAction(function (event, editor) {
            var _a = __read((0, Utils_1.checkAncestors)(editor, editor.selection.anchor.path, AccordionActions_1.accordionMatcher), 2), accordionPath = _a[1];
            (0, AccordionSelection_1.selectAccordion)(editor, accordionPath);
            event.preventDefault();
            return true;
        }),
        onBackspaceAfterCollapsedAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.OnBackspaceAfterCollapsedAccordion)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .selectionIsCollapsed()
            .inBlockType([EditorTypes_1.BlockType.Heading1, EditorTypes_1.BlockType.Heading2, EditorTypes_1.BlockType.Paragraph])
            .atStartOfBlock()
            .doAction(function (event, editor) {
            var handled = (0, AccordionActions_1.maybeBackspaceIntoHeading)(editor);
            if (handled) {
                event.preventDefault();
            }
            return handled;
        }),
        onTabInsideAccordionDummy: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.TabInsideAccordionDummy)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Tab)
            .inBlockType(EditorTypes_1.BlockType.AccordionDummy)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.moveFocusAndToggle)(editor, EditorTypes_1.BlockType.AccordionDummy, "forward");
            return true;
        }),
        onTabInsideAccordionHeading: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.TabInsideAccordionHeading)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Tab)
            .isOfAncestry(EditorTypes_1.BlockType.AccordionHeading)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.moveFocusAndToggle)(editor, EditorTypes_1.BlockType.AccordionHeading, "forward");
            return true;
        }),
        onTabInsideAccordionBody: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.TabInsideAccordionBody)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Tab)
            .isOfAncestry(EditorTypes_1.BlockType.AccordionBody)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.moveFocusAndToggle)(editor, EditorTypes_1.BlockType.AccordionBody, "forward");
            return true;
        }),
        onShiftTabInsideAccordionDummy: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.ShiftTabInsideAccordionDummy)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Tab)
            .withModifier(BehaviourBuilder_1.KeyModifier.Shift)
            .inBlockType(EditorTypes_1.BlockType.AccordionDummy)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.moveFocusAndToggle)(editor, EditorTypes_1.BlockType.AccordionDummy, "backward");
            return true;
        }),
        onShiftTabInsideAccordionHeading: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.ShiftTabInsideAccordionHeading)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Tab)
            .withModifier(BehaviourBuilder_1.KeyModifier.Shift)
            .isOfAncestry(EditorTypes_1.BlockType.AccordionHeading)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.moveFocusAndToggle)(editor, EditorTypes_1.BlockType.AccordionHeading, "backward");
            return true;
        }),
        onShiftTabInsideAccordionBody: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(BehaviourName.ShiftTabInsideAccordionBody)
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Tab)
            .withModifier(BehaviourBuilder_1.KeyModifier.Shift)
            .isOfAncestry(EditorTypes_1.BlockType.AccordionBody)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, AccordionActions_1.moveFocusAndToggle)(editor, EditorTypes_1.BlockType.AccordionBody, "backward");
            return true;
        }),
    };
};
exports.getAccordionBehaviours = getAccordionBehaviours;
